// extracted by mini-css-extract-plugin
export default {"button":"Signup_button__9e1+y","cautionTextColor":"Signup_cautionTextColor__8aLzM","loginLink":"Signup_loginLink__xJy1M"};